<template>
    <v-container v-if="this.zamawiajacy" class="page">
  <table>
    <thead>
    <tr><td>
  
  <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
    <div class="left-cointainer">
      <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
    </div>
    <div class="right-cointainer">
      Tutore Poland Sp. z o.o.<br>
      ul. Piotrkowska 157A, 90-440 Łódź<br>
      NIP: 7272812193
    </div>
  </div>
   
    </td></tr>
    </thead>
  <tbody>
  <tr><td>
  
  <p align="center" style="margin-top:20px;">
      <strong>POROZUMIENIE ZMIENIAJĄCE WARUNKI UMOWY O PRACĘ</strong> <br>
  </p>
  <p>
      Zawarte w Łodzi w dniu {{dataStartuAneksu}}  roku pomiędzy:
  </p>
  <p>
    <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego pod nr KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, kapitał zakładowy 6 481 900,00 zł,
    zwaną dalej <strong>PRACODAWCĄ</strong>, <br>
    reprezentowaną przez: 
  </p>
  <p>
    <strong>{{zamawiajacy}}</strong>,
  </p>
  <p>a</p>
  
    Imię i nazwisko: {{imieNazwisko}}
    <br/>
    Pesel: {{pesel}}
    <br/>
    Adres: {{zamieszkany}}
    <br/>
    <br/>
    zwanym dalej <strong>PRACOWNIKIEM</strong>
    <br/>
    przy czym Pracodawca i Pracownik łącznie zwani są dalej <strong>„Stronami”</strong>, a pojedynczo <strong>„Stroną”</strong>.
    <br/>
    <br/>
    <p align="center" style="margin-bottom: 0px;">
  <strong>§ 1</strong>
  </p>
  <br/>
  <p>
   Strony postanawiają wspólnie zawrzeć niniejsze porozumienie w zakresie zmiany warunków Umowy o pracę zawartej w dniu {{dataUmowy}}  roku o następującej treści ("Porozumienie"): 
    </p>
    <br/>
    <p align="center" style="margin-bottom: 0px;">
  <strong>§ 2</strong>
  </p>
  <br/>
  <p>
    1. Na mocy niniejszego Porozumienia Strony wspólnie potwierdzają, że od dnia 1 sierpnia 2024 roku dochodzi do zmiany Regulaminu Wynagradzania obowiązującego u Pracodawcy. Od tego dnia wchodzi w życie Regulamin Wynagradzania ogłoszony 17 lipca 2024 roku, Zarządzeniem Pracodawcy nr 1/2024 z dnia 16 lipca 2024 roku. <br/>
    2. W dniu 1 sierpnia 2024 roku przestaje obowiązywać Regulamin Wynagradzania ogłoszony Zarządzeniem Pracodawcy nr 2/2023 z dnia 18 stycznia 2023 roku. <br/>
    3. Wchodzący w życie Regulamin Wynagradzania zmienia warunki pracy Pracownika. <br/>
    4. Treść Regulaminu Wynagradzania stanowi Załącznik nr 1 do Porozumienia. <br/>
    5. Pracownik oświadcza, że akceptuje treść Regulaminu Wynagradzania i jego stosowanie w wersji wskazanej w Załączniku nr 1 do Porozumienia od dnia jego wejścia w życie. <br/>
    6. W związku ze zmianą siedziby firmy z dniem 01 sierpnia 2024 roku ulegnie zmianie dla Pana/Pani miejsce wykonywania pracy na: <br/>
    <br/>
    {{ trescPorozumienia1 }}
    <br/>
    {{ trescPorozumienia2 }}
    <br/>
    </p>
    <p align="center" style="margin-bottom: 0px;">
  <strong>§ 3</strong>
  </p>
  <br/>
    1. Pozostałe warunki Umowy o pracę nie ulegają zmianie.<br/>
    2. Niniejsze Porozumienie wchodzi w życie z dniem 1 sierpnia 2024 roku. <br/>
    3. Wszelkie zmiany niniejszego Porozumienia wymagają formy pisemnej pod rygorem nieważności.<br/>
    4. Porozumienie podlega prawu polskiemu.<br/>
    5. Porozumienie zostało sporządzone w dwóch jednobrzmiących egzemplarzach.<br/>
     <div class="cointainer" style="margin-top: 30px;">
      <div class="left-cointainer">
        <br/>
        <br/>
        <span style="margin-left: 0%;">W imieniu pracodawcy</span>
      </div>
      <div class="right-cointainer">
          Wyrażam zgodę.
          <br/>
          <br/>
          <span style="margin-left: 0%;">Data i podpis pracownika</span>
      </div>
  </div>
  
  
    </td></tr>
    </tbody></table>
  
    </v-container>
  </template>
  
  <script>
   export default {
    name: 'AneksPorozumienieRegulaminUOP',   
  data () {
    return {
        zamawiajacy: '',
        imieNazwisko: '',
        zamieszkany: '',
        korespondencyjny: '',
        pesel: '',
        kwota: '',
        wypo: '',
        slownie: '',
        kwotapokaz: '',
        slowniepokaz: '',
        dataAneksu: '',
        dataUmowy: '',
        trescPorozumienia1: '',
        trescPorozumienia2: '',
        dataStartuAneksu: '',
      }
    },
    created () {
      Object.entries(this.$route.query).forEach(
        ([key, value]) => { this[key] = value }
      )
    },
    methods: {
    },
    mounted () {
      if (this.zamawiajacy) {
        this.$nextTick(() => {
          window.setTimeout(() => {
            const currentURL = window.location.href
            history.replaceState(history.state, '', '/')
            window.print()
            history.replaceState(history.state, '', currentURL)
          }, 300)
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .page {
    size: 210mm 297mm;
    background-size: 100% 100%;
    line-height: 1.4;
    text-align: justify;
    margin-top: 2px;
    padding-top: 0px;
  }
  table {
    border: 1px;
    border-collapse: collapse;
    table-layout: fixed;
  }
  th, td {
    border: 1px;
    border-collapse: collapse;
  }
  .cointainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .cointainer-left {
    width: 20%;
  }
  .cointainer-right {
    width: 20%;
  }
  thead {
    display: table-header-group;
  }
  .table-border {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 5px;
  }
  .cell-in-first-table {
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 10px;
    margin-right: 10px;
  }
  ul.dashed {
    list-style-type: "- ";
    margin: 0;
  }
  .underline {
    text-decoration: underline;
  }
  .pageNum {
    position: absolute;
    right: 0px;
    font-size: 14px;
  }
  #oswiadczenie {
    padding: 20px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/PorozumienieRegulaminUOP.vue